import { PAGE_GUTTER, PAGE_GUTTER_X } from "./surface";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

// Spans gutter to gutter and centers under whatever cap a page sets, so a
// grid of clips takes the width while a settings form does not stretch.
export const PageColumn = ({
  hasVerticalPadding = true,
  className,
  children,
}: {
  hasVerticalPadding?: boolean;
  className?: string;
  children: ReactNode;
}) => (
  <div
    className={cn(
      "mx-auto w-full min-w-0",
      hasVerticalPadding ? PAGE_GUTTER : PAGE_GUTTER_X,
      className
    )}
  >
    {children}
  </div>
);
PageColumn.displayName = "Page.Column";
